import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://redballxpress.us';
const SITE_NAME = 'Red Ball Express Logistics';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const SEO_DATA = {
  '/': {
    title: 'Red Ball Express Logistics | Asset-Based Trucking Company in the USA',
    description: 'Red Ball Express is an asset-based trucking company hauling FTL, LTL, Intermodal, and Drayage freight nationwide with our own fleet. MC-1394566 | DOT-3837808. Get a free quote today.',
    keywords: 'asset based trucking company, asset based carrier, motor carrier, trucking company USA, FTL shipping, LTL freight, intermodal transport, drayage, Red Ball Express',
  },
  '/load-board': {
    title: 'Live Load Board | Available Freight Loads | Red Ball Express',
    description: 'Browse available freight loads in real-time. Find FTL, LTL, Drayage, and Intermodal loads across the USA. Carriers — sign up for instant load notifications.',
    keywords: 'load board, available loads, freight loads, trucking loads, carrier loads, find freight',
  },
  '/quote': {
    title: 'Request a Freight Quote | Red Ball Express Logistics',
    description: 'Get a free freight shipping quote from Red Ball Express. Fast, reliable FTL, LTL, Intermodal, and Drayage rates across all 48 states.',
    keywords: 'freight quote, shipping quote, trucking quote, FTL rate, LTL rate, freight estimate',
  },
  '/calculator': {
    title: 'Instant Freight Quote Calculator | Red Ball Express',
    description: 'Calculate your freight shipping cost instantly. Enter origin, destination, and equipment type for an estimated rate. Dry Van, Flatbed, Reefer, and more.',
    keywords: 'freight calculator, shipping cost calculator, trucking rate calculator, freight estimate tool',
  },
  '/services': {
    title: 'Trucking Services | FTL, LTL, Intermodal, Drayage | Red Ball Express',
    description: 'Comprehensive asset-based trucking services including Full Truckload (FTL), Less Than Truckload (LTL), Intermodal, and Drayage shipping across the USA — hauled by our own fleet.',
    keywords: 'asset based trucking, trucking services, FTL service, LTL service, intermodal shipping, drayage service, motor carrier services',
  },
  '/services/ftl': {
    title: 'Full Truckload (FTL) Shipping | Red Ball Express Logistics',
    description: 'Full Truckload freight shipping with dedicated trailers for your cargo. Competitive rates, real-time tracking, and 24/7 dispatch support.',
    keywords: 'FTL shipping, full truckload, dedicated trailer, FTL freight, truckload shipping',
  },
  '/services/ltl': {
    title: 'Less Than Truckload (LTL) Freight | Red Ball Express Logistics',
    description: 'Cost-effective LTL freight shipping for smaller loads. Share trailer space and save on shipping costs without compromising reliability.',
    keywords: 'LTL shipping, less than truckload, partial load, LTL freight, shared trailer',
  },
  '/services/intermodal': {
    title: 'Intermodal Freight Transport | Red Ball Express Logistics',
    description: 'Efficient intermodal shipping combining rail and truck transport. Reduce costs on long-haul freight with our intermodal solutions.',
    keywords: 'intermodal shipping, rail freight, intermodal transport, container shipping, rail truck combo',
  },
  '/services/drayage': {
    title: 'Port Drayage Services | Red Ball Express Logistics',
    description: 'Reliable drayage services at major US ports. Container pickup and delivery with experienced drivers and competitive rates.',
    keywords: 'drayage services, port drayage, container drayage, port trucking, container pickup',
  },
  '/services/reefer': {
    title: 'Refrigerated (Reefer) Shipping | Red Ball Express Logistics',
    description: 'Temperature-controlled freight shipping for perishable goods. Cold chain integrity from -20F to 65F with continuous monitoring.',
    keywords: 'reefer shipping, refrigerated freight, cold chain, temperature controlled transport, frozen shipping',
  },
  '/services/air-freight': {
    title: 'Air Freight Services | Red Ball Express Logistics',
    description: 'Time-critical air freight shipping — domestic and international. Same-day, next-flight-out, and charter options for urgent cargo.',
    keywords: 'air freight, air cargo, next flight out, expedited air shipping, cargo plane',
  },
  '/services/ocean-freight': {
    title: 'Ocean Freight Shipping | Red Ball Express Logistics',
    description: 'Global ocean freight services — FCL and LCL. Competitive rates on all major trade lanes with end-to-end customs and drayage.',
    keywords: 'ocean freight, sea freight, FCL, LCL, container shipping, international shipping',
  },
  '/services/warehousing': {
    title: 'Warehousing & Distribution | Red Ball Express Logistics',
    description: 'Flexible warehousing, cross-docking, and distribution services. Strategic locations near major ports and rail hubs.',
    keywords: 'warehousing, distribution, cross dock, transloading, fulfillment, storage',
  },
  '/services/cross-border': {
    title: 'Cross-Border Shipping US-Mexico-Canada | Red Ball Express Logistics',
    description: 'Seamless cross-border freight between the US, Mexico, and Canada. USMCA compliance, customs brokerage, and bilingual dispatch.',
    keywords: 'cross border shipping, Mexico freight, Canada freight, USMCA, customs brokerage, border crossing',
  },
  '/services/customs-clearance': {
    title: 'Customs Clearance & Brokerage | Red Ball Express Logistics',
    description: 'Licensed customs brokerage for import and export. HTS classification, duty optimization, and government agency compliance.',
    keywords: 'customs clearance, customs broker, import clearance, duty calculation, HTS classification',
  },
  '/services/hazmat': {
    title: 'Hazmat Shipping | Hazardous Materials Transport | Red Ball Express',
    description: 'DOT-certified hazardous materials transport for all 9 hazard classes. Compliant placarding, documentation, and emergency response.',
    keywords: 'hazmat shipping, hazardous materials, DOT certified, dangerous goods, hazmat transport',
  },
  '/services/oversize': {
    title: 'Oversize & Heavy Haul Transport | Red Ball Express Logistics',
    description: 'Specialized oversize and heavy haul freight. Permits, escorts, route surveys, and heavy-haul trailers for loads up to 200,000+ lbs.',
    keywords: 'oversize load, heavy haul, wide load, oversized freight, RGN trailer, lowboy transport',
  },
  '/contact': {
    title: 'Contact Us | Red Ball Express Logistics',
    description: 'Get in touch with Red Ball Express Logistics. Toll-free: 1 (877) 680-9272, email support@redballxpress.us. 24/7 emergency support available.',
    keywords: 'contact trucking company, asset based carrier contact, Red Ball Express phone, trucking support',
  },
  '/privacy': {
    title: 'Privacy Policy | Red Ball Express Logistics',
    description: 'How Red Ball Express Logistics collects, uses, shares, and protects information about the shippers, carriers, drivers, and visitors we work with.',
    keywords: 'Red Ball Express privacy policy, trucking privacy, carrier data privacy',
  },
  '/careers': {
    title: 'Careers at Red Ball Express | Freight Agent & Dispatcher Jobs',
    description: 'Join the Red Ball Express team. We are hiring Freight Agents, Dispatchers, and Sales Representatives. Remote and in-office positions available.',
    keywords: 'freight jobs, dispatcher jobs, freight agent jobs, trucking careers, logistics jobs',
  },
  '/carrier': {
    title: 'Carrier Registration | Get Load Notifications | Red Ball Express',
    description: 'Register as a carrier with Red Ball Express. Receive daily load notifications for OTR and Drayage freight. Quick pay available.',
    keywords: 'carrier registration, carrier sign up, load notifications, freight carrier, OTR loads, drayage loads',
  },
  '/blog': {
    title: 'Freight & Logistics Blog | Industry Insights | Red Ball Express',
    description: 'Expert insights on freight shipping, trucking industry trends, logistics tips, and supply chain strategies from Red Ball Express Logistics.',
    keywords: 'freight blog, trucking industry news, logistics tips, supply chain insights, shipping industry, freight brokerage blog',
  },
};

export const PageSEO = ({ path, children }) => {
  const seo = SEO_DATA[path] || SEO_DATA['/'];
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`;

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={canonical} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={DEFAULT_IMAGE} />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={DEFAULT_IMAGE} />
      </Helmet>
      {children}
    </>
  );
};

export const OrganizationSchema = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "MovingCompany",
        "additionalType": "http://www.productontology.org/id/Trucking_company",
        "name": "Red Ball Express Logistics",
        "alternateName": "Red Ball Express",
        "url": SITE_URL,
        "logo": `${SITE_URL}/logo.png`,
        "image": DEFAULT_IMAGE,
        "description": "Red Ball Express is an asset-based trucking company hauling FTL, LTL, Intermodal, and Drayage freight across the USA with our own fleet.",
        "telephone": "+18776809272",
        "email": "support@redballxpress.us",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "30 N Gould St #58539",
          "addressLocality": "Sheridan",
          "addressRegion": "WY",
          "postalCode": "82801",
          "addressCountry": "US"
        },
        "location": [
          {
            "@type": "Place",
            "name": "Red Ball Express — Headquarters",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "30 N Gould St #58539",
              "addressLocality": "Sheridan",
              "addressRegion": "WY",
              "postalCode": "82801",
              "addressCountry": "US"
            }
          },
          {
            "@type": "Place",
            "name": "Red Ball Express — West Coast Office",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "3111 Camino Del Rio North #400",
              "addressLocality": "San Diego",
              "addressRegion": "CA",
              "postalCode": "92108",
              "addressCountry": "US"
            }
          }
        ],
        "areaServed": {
          "@type": "Country",
          "name": "United States"
        },
        "sameAs": [],
        "priceRange": "$$",
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        },
        "hasCredential": [
          {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "MC Number",
            "name": "MC-1394566"
          },
          {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "DOT Number",
            "name": "DOT-3837808"
          }
        ]
      })}
    </script>
  </Helmet>
);

export const LocalBusinessSchema = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Red Ball Express Logistics",
        "url": SITE_URL,
        "telephone": "+18776809272",
        "email": "support@redballxpress.us",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "30 N Gould St #58539",
            "addressLocality": "Sheridan",
            "addressRegion": "WY",
            "postalCode": "82801",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "3111 Camino Del Rio North #400",
            "addressLocality": "San Diego",
            "addressRegion": "CA",
            "postalCode": "92108",
            "addressCountry": "US"
          }
        ],
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "44.7972",
          "longitude": "-106.9561"
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        }
      })}
    </script>
  </Helmet>
);

export const WebSiteSchema = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": SITE_NAME,
        "url": SITE_URL,
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${SITE_URL}/load-board?search={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      })}
    </script>
  </Helmet>
);

export const ServiceSchema = ({ name, description, url }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        "name": name,
        "description": description,
        "url": url,
        "provider": {
          "@type": "Organization",
          "name": SITE_NAME,
          "url": SITE_URL
        },
        "areaServed": {
          "@type": "Country",
          "name": "United States"
        }
      })}
    </script>
  </Helmet>
);

export const FAQSchema = ({ faqs }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      })}
    </script>
  </Helmet>
);

export const BreadcrumbSchema = ({ items }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, i) => ({
          "@type": "ListItem",
          "position": i + 1,
          "name": item.name,
          "item": item.url ? `${SITE_URL}${item.url}` : undefined
        }))
      })}
    </script>
  </Helmet>
);
